import { type TranslationTree } from '@/i18n/types';

export const messages = {
  changes_requested: {
    title: 'A equipe Bodyprint pediu um ajuste',
    fallback: 'Edite a oferta e reenvie para análise.',
  },
  rejected: {
    title: 'Oferta recusada',
    fallback: 'Edite a oferta para enviá-la de novo.',
  },
  in_review: 'Em análise pela equipe Bodyprint. Enquanto isso, a oferta não pode ser editada.',
  approved: {
    title: 'Oferta aprovada',
    campaign: 'Campanha: {{summary}}. Os números ficam em Resultados.',
    noCampaign:
      'A Bodyprint cria a campanha com o público, os lugares no app e o período. Os números aparecem em Resultados.',
  },
  archived: 'Oferta arquivada. Ela não aparece mais no app.',
} satisfies TranslationTree;
